document.addEventListener('DOMContentLoaded', () => {
  const input = document.getElementById('quantity');
  const plus = document.querySelector('[data-quantity="up"]');
  const minus = document.querySelector('[data-quantity="down"]');
  const max = 10;
  const msg = document.getElementById('qty-msg');
  let msgTimeout;

  function showMessage() {
    msg.style.display = 'block';
    msg.classList.add('active');

    clearTimeout(msgTimeout);
    msgTimeout = setTimeout(() => {
      msg.classList.remove('active');
      msg.style.display = 'none';
    }, 2000);
  }

 function update() {
  let raw = parseInt(input.value);   
  // console.log("RAW:", raw);

  let final = raw;
  if (raw > max) {
    final = max;
    showMessage();
  }
  input.value = final;
  // console.log("FINAL:", final);

  plus.classList.toggle("disabled", raw > final);
  minus.classList.toggle("disabled", final <= 1);
}

  plus.addEventListener('click', () => {
  setTimeout(update, 0); 
});

minus.addEventListener('click', () => {
  setTimeout(update, 0); 
});
input.addEventListener('input', update);
  update();
});
